import { render, staticRenderFns } from "./HeroScreen.vue?vue&type=template&id=028625f8&"
import script from "./HeroScreen.vue?vue&type=script&lang=js&"
export * from "./HeroScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports